import { CartFormData } from './types/formTypes';

/**
 * Extracts form data from the add-to-cart button's form.
 * @param submitButton - The submit button that triggered the event.
 * @returns The extracted form data or null if extraction fails.
 */
export function extractFormData(submitButton: HTMLButtonElement): CartFormData | null {
    const form = submitButton.closest('form');

    if (!form) {
        console.error('The submit button does not belong to any form.');
        return null;
    }

    const variantIdInput = form.querySelector<HTMLInputElement>('input[name="id"]');
    if (!variantIdInput || !variantIdInput.value) {
        console.error('The form does not contain a valid "id" input.');
        return null;
    }

    let quantity = 1;
    const quantityInput = form.querySelector<HTMLInputElement>('input[name="quantity"]');
    if (quantityInput && quantityInput.value) {
        quantity = parseInt(quantityInput.value, 10);
    }

    let sellingPlanId = ''
    const sellingPlan = form.querySelector<HTMLInputElement>('[name="selling_plan"]');
    
    if (sellingPlan && sellingPlan.value) {
        sellingPlanId = sellingPlan.value
    }

    const recipientName = form.querySelector<HTMLInputElement>('input[name="properties[Recipient Name]"]');
    const recipientEmail = form.querySelector<HTMLInputElement>('input[name="properties[Recipient Email]"]');
    const personalNote = form.querySelector<HTMLInputElement>('input[name="properties[Personal Note]"]');
    const senderName = form.querySelector<HTMLInputElement>('input[name="properties[Sender Name]"]');
    const senderEmail = form.querySelector<HTMLInputElement>('input[name="properties[Sender Email]"]');

    const formData: CartFormData = {
        items: [
        {
            id: parseInt(variantIdInput.value, 10),
            quantity: quantity,
            selling_plan: parseInt(sellingPlanId),
            properties: {
                'Recipient Name':  recipientName?.value,
                'Recipient Email':  recipientEmail?.value,
                'Sender Name':  senderName?.value,
                'Sender Email':  senderEmail?.value,
                'Personal Note':  personalNote?.value,
            }
        }
    ],
        sections: 'ajax-side-cart,ajax-cart-icon' // Extracted constant moved here
    };

    return formData;
}

/**
 * Parses a string of HTML into an HTML element.
 * @param section - The HTML string to parse.
 * @returns The parsed HTML element.
 */
export function parseHTMLSection(section: string): HTMLElement {
    const parser = new DOMParser();
    const doc = parser.parseFromString(section, 'text/html');
    return doc.body.firstChild as HTMLElement;
}